import React from 'react';
import { Trans } from 'react-i18next';
import util from 'utils/utils';

export default function groupInvitedContent({ events, ownerGroup = { name: 'Undefined' } }) {
  return (
    <Trans i18nKey="notifications.groupInvited">
      <b>{{ name: util.getEventUsers(events) }}</b>
      has invited you to join the group
      <b>{{ group: ownerGroup.name }}</b>
    </Trans>
  );
}
